import Auth from "./Auth";
import Aux from "./Aux";
import { AccountState } from "./types/AccountState";
import firebase from "firebase";

export default class DB
{
	getFiles(cb: (files: object) => void)
	{
		new Auth().getCurrentUser
		(
			(user) =>
			{
				const ref = firebase.database().ref(`users/${ Aux.makeStringsSafeAgain(user.email || "") }`);

				ref.on("value", (snapshot) =>
				{
					if (snapshot)
					{
						cb(Aux.makeObjectsUnsafeAgain(snapshot.val().files));
					}
					else
					{
						throw `No files found for id: ${user.email}`;
					}
				});
			},

			() =>
			{
				throw "Error!";
			},
		);
	}

	updateFiles(o: object, cb: () => void)
	{
		new Auth().getCurrentUser
		(
			(user) =>
			{
				const ref = firebase.database().ref(`users/${ Aux.makeStringsSafeAgain(user.email || "") }`);

				ref.update({ files: Aux.makeObjectsSafeAgain(o) }, (e) =>
				{
					if (e)
					{
						throw "Error!";
					}
					else
					{
						cb();
					}
				});
			},

			() =>
			{
				throw "Error!";
			},
		);
	}

	getStatus(cb: (status: AccountState) => void)
	{
		new Auth().getCurrentUser
		(
			(user) =>
			{
				const ref = firebase.database().ref(`users/${ Aux.makeStringsSafeAgain(user.email || "") }`);

				ref.on("value", (snapshot) =>
				{
					if (snapshot)
					{
						cb(snapshot.val().status as AccountState);
					}
					else
					{
						throw `No status found for id: ${user.email}`;
					}
				});
			},

			() =>
			{
				throw "Error!";
			},
		);
	}
}
